import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import PropTypes from 'prop-types';

import AddressForm from 'components/Address/AddressForm';

const addAddressDefaultPropInitialValues = {};

const AddAddress = ({
  foundAddressValues,
  initialValues = addAddressDefaultPropInitialValues,
  ...props
}) => {
  const form = useForm({
    defaultValues: {
      initialValues,
    },
  });

  const { setValue } = form;

  useEffect(() => {
    Object.keys(foundAddressValues).forEach(key => setValue(key, foundAddressValues[key]));
  }, [foundAddressValues, setValue]);

  return (
    <FormProvider {...form}>
      <AddressForm initialValues={initialValues} {...props} />
    </FormProvider>
  );
};

AddAddress.propTypes = {
  foundAddressValues: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
};

export default AddAddress;
